module.exports = __webpack_public_path__ + "img/bilge-pump-off-icon.920bb7bd.svg";